import axios from 'axios';
import env from 'src/shared/env';

/* eslint-disable import/prefer-default-export */
export function register(formValues) {
  return axios.post(`${window.getLinkHomepage()}api/Reader/Regist`, formValues);
}
